import React from "react";
import { DatabaseEnum } from "@Shape-Digital/kudzu-data/lib/types/common";
import { GridColDef } from "../../../Unknown/DataGrid";
import Typography from "../../../Unknown/Typography";
import { Appointment } from "../types";

type ColumnTranslations = {
  columnStatus: string;
  statusCheckout: string;
  statusIncomplete: string;
  statusConfirmed: string;
  statusCanceled: string;
  statusIntakeComplete: string;
  statusCheckedIn: string;
  statusNoShow: string;
  statusStudiesUnread: string;
  statusStudiesRead: string;
  statusReportsSent: string;
  statusReportsError: string;
  statusAbandoned: string;
};

type Status = DatabaseEnum["appointment_status"];

type ColumnValue = {
  status: Status;
};

const getColumnStatus = (params: {
  translations: ColumnTranslations;
}): GridColDef<Appointment, ColumnValue> => {
  const { translations } = params;

  const translationByStatus: Record<Status, string> = {
    abandoned: translations.statusAbandoned,
    checkout: translations.statusCheckout,
    incomplete: translations.statusIncomplete,
    confirmed: translations.statusConfirmed,
    canceled: translations.statusCanceled,
    intake_complete: translations.statusIntakeComplete,
    checked_in: translations.statusCheckedIn,
    no_show: translations.statusNoShow,
    studies_unread: translations.statusStudiesUnread,
    studies_read: translations.statusStudiesRead,
    reports_sent: translations.statusReportsSent,
    reports_error: translations.statusReportsError,
  };

  return {
    field: "status",
    disableColumnMenu: true,
    flex: 1,
    headerName: translations.columnStatus,
    valueGetter: (getterParams) => {
      const { status } = getterParams.row;

      return { status };
    },
    renderCell: (renderParams) => {
      if (!renderParams.value) return null;

      const statusLabel = translationByStatus[renderParams.value.status];

      return <Typography variant="body2">{statusLabel}</Typography>;
    },
  };
};

export default getColumnStatus;
